import { render, staticRenderFns } from "./jy.vue?vue&type=template&id=00972af4&scoped=true&"
import script from "./jy.vue?vue&type=script&lang=js&"
export * from "./jy.vue?vue&type=script&lang=js&"
import style0 from "./jy.vue?vue&type=style&index=0&id=00972af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00972af4",
  null
  
)

export default component.exports